// extracted by mini-css-extract-plugin
export default {"vendor-network-categories":"vendor-network-categories--mp-ddFnS","vendorNetworkCategories":"vendor-network-categories--mp-ddFnS"};